import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type SiteSettings } from "../lib/api";
import { usePageTitle } from "../lib/pageTitle";
import "./AboutPage.scss";

export function AboutPage() {
  const [site, setSite] = useState<SiteSettings | null>(null);

  usePageTitle("About");

  useEffect(() => {
    api.site().then(setSite).catch(() => {});
  }, []);

  const contactEmail = site?.social?.email || "jmartin@jmartgraphix.com";

  return (
    <div className="about page-enter container">
      <p className="about__eyebrow">About</p>
      <h1>{site?.name || "jmartgraphix"}</h1>
      <p className="about__lead">
        {site?.about ||
          "Creative professional specializing in 3D art, technical design, animation, and visual media."}
      </p>
      <div className="about__cta">
        <a className="btn btn--primary" href={`mailto:${contactEmail}`}>
          Hire / contact
        </a>
        <Link to="/portfolio" className="btn btn--ghost">
          View portfolio
        </Link>
        <Link to="/resume" className="btn btn--ghost">
          Resume
        </Link>
      </div>
      <div className="about__grid">
        <div>
          <h2>Disciplines</h2>
          <ul>
            <li>3D Modeling & Sculpting</li>
            <li>CAD & Product Visualization</li>
            <li>Animation & Motion</li>
            <li>Graphic Design & Illustration</li>
            <li>Photography & Video</li>
            <li>AI-assisted creative pipelines</li>
          </ul>
        </div>
        <div>
          <h2>Connect</h2>
          <ul className="about__links">
            <li>
              <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
            </li>
            {site?.social?.artstation && (
              <li>
                <a href={site.social.artstation} target="_blank" rel="noreferrer">
                  ArtStation
                </a>
              </li>
            )}
            {site?.social?.youtube && (
              <li>
                <a href={site.social.youtube} target="_blank" rel="noreferrer">
                  YouTube
                </a>
              </li>
            )}
            {site?.social?.vimeo && (
              <li>
                <a href={site.social.vimeo} target="_blank" rel="noreferrer">
                  Vimeo
                </a>
              </li>
            )}
            <li>
              <Link to="/resume">Resume</Link>
            </li>
            <li>
              <Link to="/portfolio">Portfolio</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
